import LinearProgress, {
  linearProgressClasses,
} from '@mui/material/LinearProgress';
import { memo } from 'react';
import styled from '@emotion/styled';
import { borderRadius } from 'presentations/views/styles';
import { blueGrayPale } from 'presentations/views/styles/color';

interface Props {
  value: number;
  className?: string;
  color?: string;
  variant?: 'indeterminate' | 'determinate';
}

const Component = memo((props: Props) => {
  return (
    <StyledProgress
      value={props.value}
      sx={{
        color: props.color,
      }}
      variant={props.variant}
      className={props.className}
    />
  );
});
const StyledProgress = styled(LinearProgress)`
  border-radius: ${borderRadius(6)};
  &.${linearProgressClasses.colorPrimary} {
    background-color: ${blueGrayPale};
  }
`;
export default Component;
